import { useViewAsStore } from '@space-shell/core/store'

class ViewAsUtils {
  static getParams() {
    const isEnabled = useViewAsStore.getState()?.isEnabled
    const role = useViewAsStore.getState()?.role

    return {
      ...(isEnabled && { roleType: role })
    }
  }

  static getHeaders() {
    const isEnabled = useViewAsStore.getState()?.isEnabled
    const role = useViewAsStore.getState()?.role

    return {
      ...(isEnabled && { 'X-View-As-Role': role })
    }
  }
}

export default ViewAsUtils
